/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type CreateCountyRecordInput = {
  id?: string | null;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<WebLinksInput | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<SearchResultInput | null> | null;
  Satisfactions?: Array<SearchResultInput | null> | null;
  Exclude?: Array<string | null> | null;
};

export type WebLinksInput = {
  LinkType?: string | null;
  LinkText?: string | null;
};

export type SearchResultInput = {
  RecID?: string | null;
  Score?: number | null;
  Name?: string | null;
  Links?: Array<WebLinksInput | null> | null;
};

export type ModelCountyRecordConditionInput = {
  searchTxt?: ModelStringInput | null;
  Date?: ModelStringInput | null;
  RecordType?: ModelStringInput | null;
  RecordDate?: ModelStringInput | null;
  CaseNumber?: ModelStringInput | null;
  RecordNumber?: ModelStringInput | null;
  BookType?: ModelStringInput | null;
  Book?: ModelStringInput | null;
  Page?: ModelStringInput | null;
  PageCount?: ModelStringInput | null;
  DocType?: ModelStringInput | null;
  Amount?: ModelStringInput | null;
  Comments?: ModelStringInput | null;
  FromParty?: ModelStringInput | null;
  ToParty?: ModelStringInput | null;
  Description?: ModelStringInput | null;
  SearchMaxScore?: ModelIntInput | null;
  Exclude?: ModelStringInput | null;
  and?: Array<ModelCountyRecordConditionInput | null> | null;
  or?: Array<ModelCountyRecordConditionInput | null> | null;
  not?: ModelCountyRecordConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type CountyRecord = {
  __typename: "CountyRecord";
  id?: string;
  pKey?: string;
  sKey?: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<WebLinks | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<SearchResult | null> | null;
  Satisfactions?: Array<SearchResult | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: ModelUserDataConnection;
  createdAt?: string;
  updatedAt?: string;
};

export type WebLinks = {
  __typename: "WebLinks";
  LinkType?: string | null;
  LinkText?: string | null;
};

export type SearchResult = {
  __typename: "SearchResult";
  RecID?: string | null;
  Score?: number | null;
  Name?: string | null;
  Links?: Array<WebLinks | null> | null;
};

export type ModelUserDataConnection = {
  __typename: "ModelUserDataConnection";
  items?: Array<UserData>;
  nextToken?: string | null;
};

export type UserData = {
  __typename: "UserData";
  id?: string;
  pKey?: string;
  sKey?: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<Note | null> | null;
  createdAt?: string;
  updatedAt?: string;
  owner?: string | null;
};

export type Note = {
  __typename: "Note";
  Seq?: number | null;
  Selected?: number | null;
  TextArea?: string | null;
};

export type UpdateCountyRecordInput = {
  id?: string | null;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<WebLinksInput | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<SearchResultInput | null> | null;
  Satisfactions?: Array<SearchResultInput | null> | null;
  Exclude?: Array<string | null> | null;
};

export type DeleteCountyRecordInput = {
  pKey: string;
  sKey: string;
};

export type CreateUserDataInput = {
  id?: string | null;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<NoteInput | null> | null;
};

export type NoteInput = {
  Seq?: number | null;
  Selected?: number | null;
  TextArea?: string | null;
};

export type ModelUserDataConditionInput = {
  pKey?: ModelStringInput | null;
  sKey?: ModelStringInput | null;
  delete?: ModelIntInput | null;
  viewed?: ModelIntInput | null;
  and?: Array<ModelUserDataConditionInput | null> | null;
  or?: Array<ModelUserDataConditionInput | null> | null;
  not?: ModelUserDataConditionInput | null;
};

export type UpdateUserDataInput = {
  id: string;
  pKey?: string | null;
  sKey?: string | null;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<NoteInput | null> | null;
};

export type DeleteUserDataInput = {
  id: string;
};

export type CreateTabProfileInput = {
  id?: string | null;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: TableProfileInput | null;
  Note?: NoteProfileInput | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
};

export enum TabType {
  Standard = "Standard",
  Favorite = "Favorite",
  Default = "Default"
}

export type TableProfileInput = {
  Columns?: Array<ColumnProfileInput | null> | null;
  PageSizeOptions?: Array<number | null> | null;
};

export type ColumnProfileInput = {
  HeaderTxt?: string | null;
  Field?: string | null;
};

export type NoteProfileInput = {
  DropTitle?: string | null;
  NotesTitle?: string | null;
  DropDownEntries?: Array<DropDownEntryInput | null> | null;
};

export type DropDownEntryInput = {
  seq?: number | null;
  value?: number | null;
  text?: string | null;
};

export type ModelTabProfileConditionInput = {
  UserID?: ModelStringInput | null;
  Title?: ModelStringInput | null;
  Type?: ModelTabTypeInput | null;
  RecordKey?: ModelStringInput | null;
  ExclusionList?: ModelStringInput | null;
  RecordsList?: ModelStringInput | null;
  and?: Array<ModelTabProfileConditionInput | null> | null;
  or?: Array<ModelTabProfileConditionInput | null> | null;
  not?: ModelTabProfileConditionInput | null;
};

export type ModelTabTypeInput = {
  eq?: TabType | null;
  ne?: TabType | null;
};

export type TabProfile = {
  __typename: "TabProfile";
  id?: string;
  UserID?: string | null;
  Title?: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: TableProfile;
  Note?: NoteProfile;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt?: string;
  updatedAt?: string;
};

export type TableProfile = {
  __typename: "TableProfile";
  Columns?: Array<ColumnProfile | null> | null;
  PageSizeOptions?: Array<number | null> | null;
};

export type ColumnProfile = {
  __typename: "ColumnProfile";
  HeaderTxt?: string | null;
  Field?: string | null;
};

export type NoteProfile = {
  __typename: "NoteProfile";
  DropTitle?: string | null;
  NotesTitle?: string | null;
  DropDownEntries?: Array<DropDownEntry | null> | null;
};

export type DropDownEntry = {
  __typename: "DropDownEntry";
  seq?: number | null;
  value?: number | null;
  text?: string | null;
};

export type UpdateTabProfileInput = {
  id: string;
  UserID?: string | null;
  Title?: string | null;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: TableProfileInput | null;
  Note?: NoteProfileInput | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
};

export type DeleteTabProfileInput = {
  id: string;
};

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelCountyRecordFilterInput = {
  id?: ModelIDInput | null;
  pKey?: ModelStringInput | null;
  sKey?: ModelStringInput | null;
  searchTxt?: ModelStringInput | null;
  Date?: ModelStringInput | null;
  RecordType?: ModelStringInput | null;
  RecordDate?: ModelStringInput | null;
  CaseNumber?: ModelStringInput | null;
  RecordNumber?: ModelStringInput | null;
  BookType?: ModelStringInput | null;
  Book?: ModelStringInput | null;
  Page?: ModelStringInput | null;
  PageCount?: ModelStringInput | null;
  DocType?: ModelStringInput | null;
  Amount?: ModelStringInput | null;
  Comments?: ModelStringInput | null;
  FromParty?: ModelStringInput | null;
  ToParty?: ModelStringInput | null;
  Description?: ModelStringInput | null;
  SearchMaxScore?: ModelIntInput | null;
  Exclude?: ModelStringInput | null;
  and?: Array<ModelCountyRecordFilterInput | null> | null;
  or?: Array<ModelCountyRecordFilterInput | null> | null;
  not?: ModelCountyRecordFilterInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelCountyRecordConnection = {
  __typename: "ModelCountyRecordConnection";
  items?: Array<CountyRecord>;
  nextToken?: string | null;
};

export type ModelUserDataFilterInput = {
  id?: ModelIDInput | null;
  pKey?: ModelStringInput | null;
  sKey?: ModelStringInput | null;
  delete?: ModelIntInput | null;
  viewed?: ModelIntInput | null;
  and?: Array<ModelUserDataFilterInput | null> | null;
  or?: Array<ModelUserDataFilterInput | null> | null;
  not?: ModelUserDataFilterInput | null;
};

export type ModelTabProfileFilterInput = {
  id?: ModelIDInput | null;
  UserID?: ModelStringInput | null;
  Title?: ModelStringInput | null;
  Type?: ModelTabTypeInput | null;
  RecordKey?: ModelStringInput | null;
  ExclusionList?: ModelStringInput | null;
  RecordsList?: ModelStringInput | null;
  and?: Array<ModelTabProfileFilterInput | null> | null;
  or?: Array<ModelTabProfileFilterInput | null> | null;
  not?: ModelTabProfileFilterInput | null;
};

export type ModelTabProfileConnection = {
  __typename: "ModelTabProfileConnection";
  items?: Array<TabProfile>;
  nextToken?: string | null;
};

export type CreateCountyRecordMutation = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCountyRecordMutation = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCountyRecordMutation = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateUserDataMutation = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type UpdateUserDataMutation = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type DeleteUserDataMutation = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type CreateTabProfileMutation = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateTabProfileMutation = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteTabProfileMutation = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type GetCountyRecordQuery = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListCountyRecordsQuery = {
  __typename: "ModelCountyRecordConnection";
  items: Array<{
    __typename: "CountyRecord";
    id: string;
    pKey: string;
    sKey: string;
    searchTxt?: string | null;
    Date?: string | null;
    RecordType?: string | null;
    RecordDate?: string | null;
    CaseNumber?: Array<string | null> | null;
    RecordNumber?: string | null;
    BookType?: string | null;
    Book?: string | null;
    Page?: string | null;
    PageCount?: string | null;
    DocType?: string | null;
    Amount?: string | null;
    Comments?: string | null;
    FromParty?: Array<string | null> | null;
    ToParty?: Array<string | null> | null;
    Description?: string | null;
    links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
    SearchMaxScore?: number | null;
    SearchMatches?: Array<{
      __typename: "SearchResult";
      RecID?: string | null;
      Score?: number | null;
      Name?: string | null;
      Links?: Array<{
        __typename: "WebLinks";
        LinkType?: string | null;
        LinkText?: string | null;
      } | null> | null;
    } | null> | null;
    Satisfactions?: Array<{
      __typename: "SearchResult";
      RecID?: string | null;
      Score?: number | null;
      Name?: string | null;
      Links?: Array<{
        __typename: "WebLinks";
        LinkType?: string | null;
        LinkText?: string | null;
      } | null> | null;
    } | null> | null;
    Exclude?: Array<string | null> | null;
    UserData?: {
      __typename: "ModelUserDataConnection";
      items: Array<{
        __typename: "UserData";
        id: string;
        pKey: string;
        sKey: string;
        delete?: number | null;
        viewed?: number | null;
        Note?: Array<{
          __typename: "Note";
          Seq?: number | null;
          Selected?: number | null;
          TextArea?: string | null;
        } | null> | null;
        createdAt: string;
        updatedAt: string;
        owner?: string | null;
      }>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetUserDataQuery = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type ListUserDatasQuery = {
  __typename: "ModelUserDataConnection";
  items: Array<{
    __typename: "UserData";
    id: string;
    pKey: string;
    sKey: string;
    delete?: number | null;
    viewed?: number | null;
    Note?: Array<{
      __typename: "Note";
      Seq?: number | null;
      Selected?: number | null;
      TextArea?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
    owner?: string | null;
  }>;
  nextToken?: string | null;
};

export type GetTabProfileQuery = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListTabProfilesQuery = {
  __typename: "ModelTabProfileConnection";
  items: Array<{
    __typename: "TabProfile";
    id: string;
    UserID?: string | null;
    Title: string;
    Type?: TabType | null;
    RecordKey?: string | null;
    Table?: {
      __typename: "TableProfile";
      Columns?: Array<{
        __typename: "ColumnProfile";
        HeaderTxt?: string | null;
        Field?: string | null;
      } | null> | null;
      PageSizeOptions?: Array<number | null> | null;
    } | null;
    Note?: {
      __typename: "NoteProfile";
      DropTitle?: string | null;
      NotesTitle?: string | null;
      DropDownEntries?: Array<{
        __typename: "DropDownEntry";
        seq?: number | null;
        value?: number | null;
        text?: string | null;
      } | null> | null;
    } | null;
    ExclusionList?: Array<string | null> | null;
    RecordsList?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type OnCreateCountyRecordSubscription = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCountyRecordSubscription = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCountyRecordSubscription = {
  __typename: "CountyRecord";
  id: string;
  pKey: string;
  sKey: string;
  searchTxt?: string | null;
  Date?: string | null;
  RecordType?: string | null;
  RecordDate?: string | null;
  CaseNumber?: Array<string | null> | null;
  RecordNumber?: string | null;
  BookType?: string | null;
  Book?: string | null;
  Page?: string | null;
  PageCount?: string | null;
  DocType?: string | null;
  Amount?: string | null;
  Comments?: string | null;
  FromParty?: Array<string | null> | null;
  ToParty?: Array<string | null> | null;
  Description?: string | null;
  links?: Array<{
    __typename: "WebLinks";
    LinkType?: string | null;
    LinkText?: string | null;
  } | null> | null;
  SearchMaxScore?: number | null;
  SearchMatches?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Satisfactions?: Array<{
    __typename: "SearchResult";
    RecID?: string | null;
    Score?: number | null;
    Name?: string | null;
    Links?: Array<{
      __typename: "WebLinks";
      LinkType?: string | null;
      LinkText?: string | null;
    } | null> | null;
  } | null> | null;
  Exclude?: Array<string | null> | null;
  UserData?: {
    __typename: "ModelUserDataConnection";
    items: Array<{
      __typename: "UserData";
      id: string;
      pKey: string;
      sKey: string;
      delete?: number | null;
      viewed?: number | null;
      Note?: Array<{
        __typename: "Note";
        Seq?: number | null;
        Selected?: number | null;
        TextArea?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
      owner?: string | null;
    }>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateUserDataSubscription = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type OnUpdateUserDataSubscription = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type OnDeleteUserDataSubscription = {
  __typename: "UserData";
  id: string;
  pKey: string;
  sKey: string;
  delete?: number | null;
  viewed?: number | null;
  Note?: Array<{
    __typename: "Note";
    Seq?: number | null;
    Selected?: number | null;
    TextArea?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
  owner?: string | null;
};

export type OnCreateTabProfileSubscription = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateTabProfileSubscription = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteTabProfileSubscription = {
  __typename: "TabProfile";
  id: string;
  UserID?: string | null;
  Title: string;
  Type?: TabType | null;
  RecordKey?: string | null;
  Table?: {
    __typename: "TableProfile";
    Columns?: Array<{
      __typename: "ColumnProfile";
      HeaderTxt?: string | null;
      Field?: string | null;
    } | null> | null;
    PageSizeOptions?: Array<number | null> | null;
  } | null;
  Note?: {
    __typename: "NoteProfile";
    DropTitle?: string | null;
    NotesTitle?: string | null;
    DropDownEntries?: Array<{
      __typename: "DropDownEntry";
      seq?: number | null;
      value?: number | null;
      text?: string | null;
    } | null> | null;
  } | null;
  ExclusionList?: Array<string | null> | null;
  RecordsList?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreateCountyRecord(
    input: CreateCountyRecordInput,
    condition?: ModelCountyRecordConditionInput
  ): Promise<CreateCountyRecordMutation> {
    const statement = `mutation CreateCountyRecord($input: CreateCountyRecordInput!, $condition: ModelCountyRecordConditionInput) {
        createCountyRecord(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCountyRecordMutation>response.data.createCountyRecord;
  }
  async UpdateCountyRecord(
    input: UpdateCountyRecordInput,
    condition?: ModelCountyRecordConditionInput
  ): Promise<UpdateCountyRecordMutation> {
    const statement = `mutation UpdateCountyRecord($input: UpdateCountyRecordInput!, $condition: ModelCountyRecordConditionInput) {
        updateCountyRecord(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCountyRecordMutation>response.data.updateCountyRecord;
  }
  async DeleteCountyRecord(
    input: DeleteCountyRecordInput,
    condition?: ModelCountyRecordConditionInput
  ): Promise<DeleteCountyRecordMutation> {
    const statement = `mutation DeleteCountyRecord($input: DeleteCountyRecordInput!, $condition: ModelCountyRecordConditionInput) {
        deleteCountyRecord(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCountyRecordMutation>response.data.deleteCountyRecord;
  }
  async CreateUserData(
    input: CreateUserDataInput,
    condition?: ModelUserDataConditionInput
  ): Promise<CreateUserDataMutation> {
    const statement = `mutation CreateUserData($input: CreateUserDataInput!, $condition: ModelUserDataConditionInput) {
        createUserData(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateUserDataMutation>response.data.createUserData;
  }
  async UpdateUserData(
    input: UpdateUserDataInput,
    condition?: ModelUserDataConditionInput
  ): Promise<UpdateUserDataMutation> {
    const statement = `mutation UpdateUserData($input: UpdateUserDataInput!, $condition: ModelUserDataConditionInput) {
        updateUserData(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateUserDataMutation>response.data.updateUserData;
  }
  async DeleteUserData(
    input: DeleteUserDataInput,
    condition?: ModelUserDataConditionInput
  ): Promise<DeleteUserDataMutation> {
    const statement = `mutation DeleteUserData($input: DeleteUserDataInput!, $condition: ModelUserDataConditionInput) {
        deleteUserData(input: $input, condition: $condition) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteUserDataMutation>response.data.deleteUserData;
  }
  async CreateTabProfile(
    input: CreateTabProfileInput,
    condition?: ModelTabProfileConditionInput
  ): Promise<CreateTabProfileMutation> {
    const statement = `mutation CreateTabProfile($input: CreateTabProfileInput!, $condition: ModelTabProfileConditionInput) {
        createTabProfile(input: $input, condition: $condition) {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateTabProfileMutation>response.data.createTabProfile;
  }
  async UpdateTabProfile(
    input: UpdateTabProfileInput,
    condition?: ModelTabProfileConditionInput
  ): Promise<UpdateTabProfileMutation> {
    const statement = `mutation UpdateTabProfile($input: UpdateTabProfileInput!, $condition: ModelTabProfileConditionInput) {
        updateTabProfile(input: $input, condition: $condition) {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateTabProfileMutation>response.data.updateTabProfile;
  }
  async DeleteTabProfile(
    input: DeleteTabProfileInput,
    condition?: ModelTabProfileConditionInput
  ): Promise<DeleteTabProfileMutation> {
    const statement = `mutation DeleteTabProfile($input: DeleteTabProfileInput!, $condition: ModelTabProfileConditionInput) {
        deleteTabProfile(input: $input, condition: $condition) {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteTabProfileMutation>response.data.deleteTabProfile;
  }
  async GetCountyRecord(
    pKey: string,
    sKey: string
  ): Promise<GetCountyRecordQuery> {
    const statement = `query GetCountyRecord($pKey: String!, $sKey: String!) {
        getCountyRecord(pKey: $pKey, sKey: $sKey) {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      pKey,
      sKey
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCountyRecordQuery>response.data.getCountyRecord;
  }
  async ListCountyRecords(
    pKey?: string,
    sKey?: ModelStringKeyConditionInput,
    filter?: ModelCountyRecordFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListCountyRecordsQuery> {
    const statement = `query ListCountyRecords($pKey: String, $sKey: ModelStringKeyConditionInput, $filter: ModelCountyRecordFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listCountyRecords(pKey: $pKey, sKey: $sKey, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            id
            pKey
            sKey
            searchTxt
            Date
            RecordType
            RecordDate
            CaseNumber
            RecordNumber
            BookType
            Book
            Page
            PageCount
            DocType
            Amount
            Comments
            FromParty
            ToParty
            Description
            links {
              __typename
              LinkType
              LinkText
            }
            SearchMaxScore
            SearchMatches {
              __typename
              RecID
              Score
              Name
              Links {
                __typename
                LinkType
                LinkText
              }
            }
            Satisfactions {
              __typename
              RecID
              Score
              Name
              Links {
                __typename
                LinkType
                LinkText
              }
            }
            Exclude
            UserData {
              __typename
              items {
                __typename
                id
                pKey
                sKey
                delete
                viewed
                Note {
                  __typename
                  Seq
                  Selected
                  TextArea
                }
                createdAt
                updatedAt
                owner
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (pKey) {
      gqlAPIServiceArguments.pKey = pKey;
    }
    if (sKey) {
      gqlAPIServiceArguments.sKey = sKey;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCountyRecordsQuery>response.data.listCountyRecords;
  }
  async GetUserData(id: string): Promise<GetUserDataQuery> {
    const statement = `query GetUserData($id: ID!) {
        getUserData(id: $id) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserDataQuery>response.data.getUserData;
  }
  async ListUserDatas(
    filter?: ModelUserDataFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListUserDatasQuery> {
    const statement = `query ListUserDatas($filter: ModelUserDataFilterInput, $limit: Int, $nextToken: String) {
        listUserDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            pKey
            sKey
            delete
            viewed
            Note {
              __typename
              Seq
              Selected
              TextArea
            }
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListUserDatasQuery>response.data.listUserDatas;
  }
  async GetTabProfile(id: string): Promise<GetTabProfileQuery> {
    const statement = `query GetTabProfile($id: ID!) {
        getTabProfile(id: $id) {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetTabProfileQuery>response.data.getTabProfile;
  }
  async ListTabProfiles(
    filter?: ModelTabProfileFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTabProfilesQuery> {
    const statement = `query ListTabProfiles($filter: ModelTabProfileFilterInput, $limit: Int, $nextToken: String) {
        listTabProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            UserID
            Title
            Type
            RecordKey
            Table {
              __typename
              Columns {
                __typename
                HeaderTxt
                Field
              }
              PageSizeOptions
            }
            Note {
              __typename
              DropTitle
              NotesTitle
              DropDownEntries {
                __typename
                seq
                value
                text
              }
            }
            ExclusionList
            RecordsList
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTabProfilesQuery>response.data.listTabProfiles;
  }
  OnCreateCountyRecordListener: Observable<
    SubscriptionResponse<OnCreateCountyRecordSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateCountyRecord {
        onCreateCountyRecord {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateCountyRecordSubscription>>;

  OnUpdateCountyRecordListener: Observable<
    SubscriptionResponse<OnUpdateCountyRecordSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateCountyRecord {
        onUpdateCountyRecord {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateCountyRecordSubscription>>;

  OnDeleteCountyRecordListener: Observable<
    SubscriptionResponse<OnDeleteCountyRecordSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteCountyRecord {
        onDeleteCountyRecord {
          __typename
          id
          pKey
          sKey
          searchTxt
          Date
          RecordType
          RecordDate
          CaseNumber
          RecordNumber
          BookType
          Book
          Page
          PageCount
          DocType
          Amount
          Comments
          FromParty
          ToParty
          Description
          links {
            __typename
            LinkType
            LinkText
          }
          SearchMaxScore
          SearchMatches {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Satisfactions {
            __typename
            RecID
            Score
            Name
            Links {
              __typename
              LinkType
              LinkText
            }
          }
          Exclude
          UserData {
            __typename
            items {
              __typename
              id
              pKey
              sKey
              delete
              viewed
              Note {
                __typename
                Seq
                Selected
                TextArea
              }
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteCountyRecordSubscription>>;

  OnCreateUserDataListener: Observable<
    SubscriptionResponse<OnCreateUserDataSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateUserData($owner: String!) {
        onCreateUserData(owner: $owner) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateUserDataSubscription>>;

  OnUpdateUserDataListener: Observable<
    SubscriptionResponse<OnUpdateUserDataSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateUserData($owner: String!) {
        onUpdateUserData(owner: $owner) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateUserDataSubscription>>;

  OnDeleteUserDataListener: Observable<
    SubscriptionResponse<OnDeleteUserDataSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteUserData($owner: String!) {
        onDeleteUserData(owner: $owner) {
          __typename
          id
          pKey
          sKey
          delete
          viewed
          Note {
            __typename
            Seq
            Selected
            TextArea
          }
          createdAt
          updatedAt
          owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteUserDataSubscription>>;

  OnCreateTabProfileListener: Observable<
    SubscriptionResponse<OnCreateTabProfileSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateTabProfile {
        onCreateTabProfile {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateTabProfileSubscription>>;

  OnUpdateTabProfileListener: Observable<
    SubscriptionResponse<OnUpdateTabProfileSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateTabProfile {
        onUpdateTabProfile {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateTabProfileSubscription>>;

  OnDeleteTabProfileListener: Observable<
    SubscriptionResponse<OnDeleteTabProfileSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteTabProfile {
        onDeleteTabProfile {
          __typename
          id
          UserID
          Title
          Type
          RecordKey
          Table {
            __typename
            Columns {
              __typename
              HeaderTxt
              Field
            }
            PageSizeOptions
          }
          Note {
            __typename
            DropTitle
            NotesTitle
            DropDownEntries {
              __typename
              seq
              value
              text
            }
          }
          ExclusionList
          RecordsList
          createdAt
          updatedAt
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteTabProfileSubscription>>;
}
